import QuestionType from '@/models/question_type';
import QuestionParam from '@/models/question_param';

/* ************************************************************************* *
 * WARNING                                                                   *
 *                                                                           *
 * DO NOT MODIFIY THESE VALUES WITHOUT ALSO MODIFYING THE VALUES IN RIDDLER! *
 * ************************************************************************* */

const QuestionTypes = {
	'text':       new QuestionType( { id: 1, name: 'text'        } ),
	'comment':    new QuestionType( { id: 2, name: 'comment'     } ),
	'checkbox':   new QuestionType( { id: 3, name: 'checkbox',   includeChoices:  1,  choicesName: 'choices' } ),
	'radiogroup': new QuestionType( { id: 4, name: 'radiogroup', includeInScoring: 1, includeChoices:  1, choicesName: 'choices'    } ),
	'dropdown':   new QuestionType( { id: 5, name: 'dropdown',   includeInScoring: 1, includeChoices:  1, choicesName: 'choices'    } ),
	'rating':     new QuestionType( { id: 6, name: 'rating',     includeInScoring: 1, includeChoices:  1, choicesName: 'rateValues' } ),
	'boolean':    new QuestionType( { id: 7, name: 'boolean'     } ),
	'matrix':     new QuestionType( { id: 8, name: 'matrix',     includeInScoring: 1, includeChoices:  1, choicesName: 'columns' } ),
	'row':        new QuestionType( { id: 9, name: 'row'         } ),
	'html':		  new QuestionType( { id: 10, name: 'html',      includeInScoring: 0} ),
}

const QuestionParams = {
	'description':          new QuestionParam( { id: 1,  name: 'description' } ),
	'isRequired':           new QuestionParam( { id: 2,  name: 'isRequired', convertToBool: true } ),
	'requiredErrorText':    new QuestionParam( { id: 3,  name: 'requiredErrorText' } ),
	'enableIf':             new QuestionParam( { id: 4,  name: 'enableIf' } ),
	'visible':              new QuestionParam( { id: 5,  name: 'visible', convertToBool: true } ),
	'visibleIf':            new QuestionParam( { id: 6,  name: 'visibleIf' } ),
	'placeHolder':          new QuestionParam( { id: 7,  name: 'placeHolder' } ),
	'hasOther':             new QuestionParam( { id: 8,  name: 'hasOther', convertToBool: true } ),
	'otherErrorText':       new QuestionParam( { id: 9,  name: 'otherErrorText' } ),
	'otherText':            new QuestionParam( { id: 10, name: 'otherText' } ),
	'storeOthersAsComment': new QuestionParam( { id: 11, name: 'storeOthersAsComment' } ),
	'hasComment':           new QuestionParam( { id: 12, name: 'hasComment', convertToBool: true } ),
	'commentText':          new QuestionParam( { id: 13, name: 'commentText' } ),
	'optionsCaption':       new QuestionParam( { id: 14, name: 'optionsCaption' } ),
	//'rows':                 new QuestionParam( { id: 15, name: 'rows' } ),
	//'columns':              new QuestionParam( { id: 16, name: 'columns' } ),
	'valueFalse':           new QuestionParam( { id: 17, name: 'valueFalse' } ),
	'valueTrue':            new QuestionParam( { id: 18, name: 'valueTrue' } ),
	'showTitle':            new QuestionParam( { id: 19, name: 'showTitle' } ),
	'label':                new QuestionParam( { id: 20, name: 'label' } ),
	'rateMax':              new QuestionParam( { id: 21, name: 'rateMax' } ),
	'rateMin':              new QuestionParam( { id: 22, name: 'rateMin' } ),
	'rateStep':             new QuestionParam( { id: 23, name: 'rateStep' } ),
	'maxRateDescription':   new QuestionParam( { id: 24, name: 'maxRateDescription' } ),
	'minRateDescription':   new QuestionParam( { id: 25, name: 'minRateDescription' } ),
	'defaultValue':         new QuestionParam( { id: 26, name: 'defaultValue' } )
}

export {
	QuestionTypes,
	QuestionParams
}
